import { SmartPayOnboardingFormData } from '../../../../types';
import { useSignupDialogOnboardingContext } from '../contexts/SignupDialogOnboardingContextProvider';

export const useSignupDialogForm = () => {
    const { formData, setFormData, setOnboardError, setFormDefaults } = useSignupDialogOnboardingContext();

    const updateFormData = (data: Partial<SmartPayOnboardingFormData>) => {
        setFormData(prevFormData => ({
            ...prevFormData!,
            ...data,
        }));
    };

    const onFormChange = e => {
        const { values } = e;
        updateFormData(values);
    };

    const resetForm = () => {
        setFormDefaults();
        setOnboardError(null);
    };

    return {
        formData,
        onFormChange,
        updateFormData,
        resetForm,
    };
};
